module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("A tremendous thank-you to my husband, Matt—without your unflinching support and encouragement, this book would not have been written. Thank you, Davin, for patiently occupying yourself with Legos and the like during my many hours of sewing and writing.")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Thank you, Mom, from whom I inherited any artistic talent I have: You bought me my first sewing machine and supported, encouraged, and often commissioned the myriad of creative hobbies I’ve had over the years. It was your random idea to go to a quilt festival one year that started this whole thing. I love you.")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("I am hugely grateful to Stash Books and the whole C&T Publishing staff. Thank you especially to Lynn Koolish, Debbie Rodgers, Roxane Cerda, and everyone else who was involved in making this book a reality. Your suggestions, ideas, and direction made this book what it is. Thank you all so much. And thank you Kristy Zacharias and April Mostek for making this book so beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Thank you also to Timeless Treasures, Michael Miller Fabrics, Robert Kaufman Fabrics, The Warm Company, Prym Consumer USA, Pellon, and all the other companies who generously provided the incredible materials for the quilts in this book. It was a pleasure to work with your wonderful products.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a324741","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_ack.vue
// module id = 66
// module chunks = 0